var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEigen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0237732,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-0.042554 0 0.0237732)",
    fill: "white",
    fillOpacity: 0.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.17 9.25L17.17 7L14.92 7L14.92 9.25L17.17 9.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.58 16L12.58 7L8.08 7L8.08 16L12.58 16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.58 25L12.58 16L8.08 16L8.08 25L12.58 25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 16L21.58 11.5L19.33 11.5L19.33 16L21.58 16Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.33 25L19.33 20.5L17.08 20.5L17.08 25L19.33 25Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.58 25L21.58 20.5L19.33 20.5L19.33 25L21.58 25Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.83 25L14.83 20.5L12.58 20.5L12.58 25L14.83 25Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.83 11.5L23.83 7L21.58 7L21.58 11.5L23.83 11.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.33 16L19.33 7L17.08 7L17.08 16L19.33 16Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.08 25L17.08 16L14.83 16L14.83 25L17.08 25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEigen);
export default __webpack_public_path__ + "static/media/EIGEN.2c597299f22501788748e57880afba6a.svg";
export { ForwardRef as ReactComponent };